export default () => {
  if (import.meta.server) return undefined;

  const ua = navigator.userAgent || navigator.vendor || (window as any).opera;

  // Basic WebView detection logic
  const webViewRegexes = [
    /FBAN|FBAV/, // Facebook in-app browser
    /Instagram/, // Instagram in-app browser
    /Twitter/, // Twitter in-app browser
    /Line/, // LINE browser
    /LinkedInApp/, // LinkedIn
    /Snapchat/, // Snapchat
    /TikTok/, // TikTok
    /WebView/, // generic Android WebView
    /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/, // iOS WebView
  ];

  return webViewRegexes.some((regex) => regex.test(ua));
};
